/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentExchangeStatus } from './AppointmentExchangeStatus';
import {
    AppointmentExchangeStatusFromJSON,
    AppointmentExchangeStatusFromJSONTyped,
    AppointmentExchangeStatusToJSON,
    AppointmentExchangeStatusToJSONTyped,
} from './AppointmentExchangeStatus';

/**
 * 
 * @export
 * @interface AppointmentExchangeResponse
 */
export interface AppointmentExchangeResponse {
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    id: string;
    /**
     * 
     * @type {AppointmentExchangeStatus}
     * @memberof AppointmentExchangeResponse
     */
    status: AppointmentExchangeStatus;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    appointmentId: string;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentExchangeResponse
     */
    appointmentStartUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentExchangeResponse
     */
    appointmentEndUtc: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentExchangeResponse
     */
    isAllDay: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    purposeKey: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    location: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    details: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentExchangeResponse
     */
    createdAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    createdByCounselorId: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    counselorUserCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentExchangeResponse
     */
    requestedPurposeKeys: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    note: string | null;
    /**
     * 
     * @type {number}
     * @memberof AppointmentExchangeResponse
     */
    offersCount: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentExchangeResponse
     */
    pendingOffersCount: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentExchangeResponse
     */
    ownPendingOfferId: string | null;
}



/**
 * Check if a given object implements the AppointmentExchangeResponse interface.
 */
export function instanceOfAppointmentExchangeResponse(value: object): value is AppointmentExchangeResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('appointmentStartUtc' in value) || value['appointmentStartUtc'] === undefined) return false;
    if (!('appointmentEndUtc' in value) || value['appointmentEndUtc'] === undefined) return false;
    if (!('isAllDay' in value) || value['isAllDay'] === undefined) return false;
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('createdAtUtc' in value) || value['createdAtUtc'] === undefined) return false;
    if (!('createdByCounselorId' in value) || value['createdByCounselorId'] === undefined) return false;
    if (!('counselorUserCode' in value) || value['counselorUserCode'] === undefined) return false;
    if (!('requestedPurposeKeys' in value) || value['requestedPurposeKeys'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('offersCount' in value) || value['offersCount'] === undefined) return false;
    if (!('pendingOffersCount' in value) || value['pendingOffersCount'] === undefined) return false;
    if (!('ownPendingOfferId' in value) || value['ownPendingOfferId'] === undefined) return false;
    return true;
}

export function AppointmentExchangeResponseFromJSON(json: any): AppointmentExchangeResponse {
    return AppointmentExchangeResponseFromJSONTyped(json, false);
}

export function AppointmentExchangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentExchangeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': AppointmentExchangeStatusFromJSON(json['status']),
        'appointmentId': json['appointmentId'],
        'appointmentStartUtc': (new Date(json['appointmentStartUtc'])),
        'appointmentEndUtc': (new Date(json['appointmentEndUtc'])),
        'isAllDay': json['isAllDay'],
        'purposeKey': json['purposeKey'],
        'location': json['location'],
        'details': json['details'],
        'createdAtUtc': (new Date(json['createdAtUtc'])),
        'createdByCounselorId': json['createdByCounselorId'],
        'counselorUserCode': json['counselorUserCode'],
        'requestedPurposeKeys': json['requestedPurposeKeys'],
        'note': json['note'],
        'offersCount': json['offersCount'],
        'pendingOffersCount': json['pendingOffersCount'],
        'ownPendingOfferId': json['ownPendingOfferId'],
    };
}

export function AppointmentExchangeResponseToJSON(json: any): AppointmentExchangeResponse {
    return AppointmentExchangeResponseToJSONTyped(json, false);
}

export function AppointmentExchangeResponseToJSONTyped(value?: AppointmentExchangeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': AppointmentExchangeStatusToJSON(value['status']),
        'appointmentId': value['appointmentId'],
        'appointmentStartUtc': value['appointmentStartUtc'].toISOString(),
        'appointmentEndUtc': value['appointmentEndUtc'].toISOString(),
        'isAllDay': value['isAllDay'],
        'purposeKey': value['purposeKey'],
        'location': value['location'],
        'details': value['details'],
        'createdAtUtc': value['createdAtUtc'].toISOString(),
        'createdByCounselorId': value['createdByCounselorId'],
        'counselorUserCode': value['counselorUserCode'],
        'requestedPurposeKeys': value['requestedPurposeKeys'],
        'note': value['note'],
        'offersCount': value['offersCount'],
        'pendingOffersCount': value['pendingOffersCount'],
        'ownPendingOfferId': value['ownPendingOfferId'],
    };
}

